import styled from 'styled-components'

export const Badge = styled.div`
  align-items: center;
  background-color: #F8F9FA;
  border-radius: 0.125rem;
  color: #3C6E90;
  display: flex;
  justify-content: center;
  margin-left: 1.25rem;
  max-width: 3.75rem;
`